'use strict';

angular.module('clientDashboardApp' ).directive('widgetLoading', function ($window) {
  return {
    restrict: 'A',
    transclude: true,
    template: `
              <div class="widget-loading">
                <div class="widget-loading-content" ng-class="{'blur' : widgetLoading}">
                    <ng-transclude></ng-transclude>
                </div>
                <div ng-if="widgetLoading" class="widget-loading-overlay text-center">
                  <div class="widget-loading-overlay-inner-wrapper">
                    <div class="loading-dialog"><h4 class="loading">Loading... </h4><i class="fas fa-spinner fa-spin fa-2x"></i></div>
                  </div>
                </div>
              </div>`,
    scope: {
      widgetLoading: '=',
    }
  };
});
